// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-tag--default[data-v-32af58f6]{display:flex;align-items:center;justify-content:center;border-radius:9999px;padding:8px 16px;border:1.5px solid #2bc5cb;background:transparent}.label-tag--textOnly[data-v-32af58f6]{border:none;background:transparent;padding:0}.label-tag__text[data-v-32af58f6]{text-align:center;font-size:14px;font-weight:600;line-height:16px;color:#2bc5cb}", ""]);
// Exports
module.exports = exports;
